const getCurrentISODayTime = () => {
    const now = new Date(); // Use actual current date and time
    
    // Map day number to abbreviated day name for consistency
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const isoDay = dayNames[now.getDay()]; // e.g., "Sun", "Mon", "Tue"
    
    // Get time in 12-hour format with AM/PM
    const isoTime = now.toLocaleTimeString('en-IN', {
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
    });

    return { day: isoDay, time: isoTime }
}


const parseTimeToMinutes = (timeStr) => {
    const [time, modifier] = timeStr.split(' ');
    const [hours, minutes, seconds] = time.split(':').map(Number);

    let totalHours = hours % 12 + (modifier === 'pm' ? 12 : 0);
    return totalHours * 60 + minutes + seconds / 60;
}


export const isButtonEnabled = () => {
    const { day, time } = getCurrentISODayTime();

    // const ranges = {
    //     Mon: [["10:00:00 am", "2:00:00 pm"]],
    //     Wed: [["2:00:00 pm", "11:59:59 pm"]],
    //     Thu: [["12:00:00 am", "2:00:00 pm"]]
    // };

    /* ---for testing--- */
    const ranges = {
        Mon: [["12:00:00 am", "11:59:59 pm"]],
        Tue: [["12:00:00 am", "11:59:59 pm"]],
        Wed: [["12:00:00 am", "11:59:59 pm"]],
        Thu: [["12:00:00 am", "11:59:59 pm"]],
        Fri: [["12:00:00 am", "11:59:59 pm"]],
        Sat: [["12:00:00 am", "11:59:59 pm"]],
        Sun: [["12:00:00 am", "11:59:59 pm"]],
    };

    const todayRanges = ranges[day];
    if (!todayRanges) return false;

    return todayRanges.some(([start, end]) => parseTimeToMinutes(time) >= parseTimeToMinutes(start) && parseTimeToMinutes(time) <= parseTimeToMinutes(end));
}



export const isInputEnabled = (label) => {
    const { day, time } = getCurrentISODayTime();
    const inputFields = {
        Mon: 0, Tue: 1, Wed: 2,
        Thu: 3, Fri: 4, Sat: 5,
        Sun: 6, Cascade: "any",
        Format:'any', Line: "any", "Reason for change": "any",
        "Site code": "any", "Priority": "any"
    }

    // const ranges = {
    //     Mon: ["10:00:00 am", "2:00:00 pm"],
    //     Wed: ["2:00:00 pm", "11:59:59 pm"],
    //     Thu: ["12:00:00 am", "2:00:00 pm"]
    // };

    /* ---for testing--- */
    const ranges = {
        Mon: ["12:00:00 am", "11:59:59 pm"],
        Tue: ["12:00:00 am", "11:59:59 pm"],
        Wed: ["12:00:00 am", "11:59:59 pm"],
        Thu: ["12:00:00 am", "11:59:59 pm"],
        Fri: ["12:00:00 am", "11:59:59 pm"],
        Sat: ["12:00:00 am", "11:59:59 pm"],
        Sun: ["12:00:00 am", "11:59:59 pm"],
    };

    const currentDay = inputFields[day];
    const field = inputFields[label];
    const inTimeRange = (startTime, endTime) => parseTimeToMinutes(time) >= parseTimeToMinutes(startTime) && parseTimeToMinutes(time) <= parseTimeToMinutes(endTime);

    const range = ranges[day];
    ;

    if (range) {
        const isTimeAllow = inTimeRange(range[0], range[1]);
        if (field >= currentDay || field === 'any') {
            if (isTimeAllow) {
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    } else {
        return true;
    }
}


const getCurrentManualFlag = () => {
    const { day, time } = getCurrentISODayTime();
    // const ranges = {
    //     Mon: ["10:00:00 am", "11:59:59 pm"],
    //     Tue: ["12:00:00 am", "11:59:59 pm"],
    //     Wed: ["12:00:00 am", "1:59:59 pm"],
    // };

    const ranges = {
        Mon: ["12:00:00 am", "11:59:59 pm"],
        Tue: ["12:00:00 am", "11:59:59 pm"],
        Wed: ["12:00:00 am", "11:59:59 pm"],
        Thu: ["12:00:00 am", "11:59:59 pm"],
        Fri: ["12:00:00 am", "11:59:59 pm"],
        Sat: ["12:00:00 am", "11:59:59 pm"],
        Sun: ["12:00:00 am", "11:59:59 pm"],
    };

    const inTimeRange = (startTime, endTime) => parseTimeToMinutes(time) >= parseTimeToMinutes(startTime) && parseTimeToMinutes(time) <= parseTimeToMinutes(endTime);

    const range = ranges[day];

    if (range) {
        const flagTime = inTimeRange(range[0], range[1]);
        if (flagTime) {
            return "M1";
        } else {
            // return "M2"; commented coz business asked to remove M2
            return "M1";
        }
    } else {
        // return "M2"; commented coz business asked to remove M2
        return "M1";
    }
}


export const cascadeLineOptions = (arr, groupKeys) => {
    if (!arr.length) return [];
    const result = new Map();

    for (const item of arr) {
        // Generate dynamic key
        const key = groupKeys.map(key => item[key] || "").join(":");
        if (!result.has(key)) {
            result.set(key, { cascades: new Set(), lines: new Set() });
        }
        const group = result.get(key);
        group.cascades.add(item.Cascade);
        group.lines.add(item.Line);
    }
    // Convert Sets to Arrays
    for (const [_, value] of result) {
        value.cascades = [...value.cascades];
        value.lines = [...value.lines];
    }
    return result;
}




const getCurrentWeekDateObject = (weekNumber, year) => {
    const pad = num => num.toString().padStart(2, '0');
    
    // If year is not provided, determine the ISO year for the current date
    if (!year) {
        const now = new Date();
        const currentYear = now.getFullYear();
        
        // Get ISO week info for current date
        const getISOWeek = (date) => {
            const target = new Date(date);
            target.setHours(0, 0, 0, 0);
            target.setDate(target.getDate() + 4 - (target.getDay() || 7));
            const yearStart = new Date(target.getFullYear(), 0, 1);
            const weekNo = Math.ceil((((target - yearStart) / 86400000) + 1) / 7);
            return { week: weekNo, year: target.getFullYear() };
        };
        
        const currentWeekInfo = getISOWeek(now);
        
        // If the week numbers match, use the ISO year from current date
        if (currentWeekInfo.week === weekNumber) {
            year = currentWeekInfo.year;
        } else {
            // Otherwise, use current calendar year as fallback
            year = currentYear;
        }
    }
    
    console.log("weekNumber:", weekNumber, "year:", year);
    
    // Get the date of the Monday of the given ISO week
    const getMondayOfISOWeek = (week, year) => {
        // January 4th is always in week 1 of the ISO year
        const jan4 = new Date(year, 0, 4);
        
        // Get day of week for Jan 4 (0=Sun, 1=Mon, ..., 6=Sat)
        // Convert to ISO day (1=Mon, 7=Sun)
        const jan4DayOfWeek = jan4.getDay();
        const jan4ISODay = jan4DayOfWeek === 0 ? 7 : jan4DayOfWeek;
        
        // Calculate the Monday of week 1
        const week1Monday = new Date(jan4);
        week1Monday.setDate(jan4.getDate() - jan4ISODay + 1);
        
        // Calculate the target Monday by adding (week - 1) weeks
        const targetMonday = new Date(week1Monday);
        targetMonday.setDate(week1Monday.getDate() + (week - 1) * 7);
        
        return targetMonday;
    };

    const monday = getMondayOfISOWeek(weekNumber, year);

    // Generate dates from Monday to Sunday
    const weekDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    const formattedDates = {};

    weekDays.forEach((day, index) => {
        const date = new Date(monday);
        date.setDate(monday.getDate() + index);
        formattedDates[day] = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    });

    return formattedDates;
}

export const differentiateRowsByDate = (obj, isDraft = false) => {
    try {
        const daysKey = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };
        const days = Object.keys(daysKey);
        const currentWeekDates = getCurrentWeekDateObject(obj["Week"]);
        const currentDay = getCurrentISODayTime().day;
        const constValues = { ...obj.constValues };
        delete obj.constValues
        delete obj.id;
        delete obj.isUpdated;
        delete obj.isAdded;
        delete obj.cascadeOptions;
        delete obj.lineOptions
        delete obj.Total;
        const dayIndex = daysKey[currentDay];
        let arr = []
        
        // Handle M2 flag first (outside the main loop)
        if (obj.Flag === 'M2' && !obj.IsAddNewCBU && !obj.IsDuplicateRow) {
            if (obj.Cascade !== constValues.Cascade || obj.Line !== constValues.Line) {
                // NEW Cascade/Line object (future days)
                let newCascadeObj = {
                    ...obj,
                    Cascade: obj.Cascade,
                    Line: obj.Line,
                    PreCascade: constValues.Cascade,
                    PreLine: constValues.Line,
                    requirement: obj["SAP weekly plan"],
                    "Reason for change": obj["Reason for change"],
                    IsDraft: isDraft ? 1 : 0,
                    IsIgnore: 1,
                    IsAddNewCBU: 0,
                    isSubmitted : isDraft ? 0 : 1
                };

                // OLD Cascade/Line object (past days)
                let oldCascadeObj = {
                    ...obj,
                    Cascade: constValues.Cascade,
                    Line: constValues.Line,
                    PreCascade: constValues.Cascade,
                    PreLine: constValues.Line,
                    requirement: obj["SAP weekly plan"],
                    "Reason for change": constValues["Reason for change"],
                    IsDraft: isDraft ? 1 : 0,
                    IsIgnore: 1,
                    IsAddNewCBU: 0,
                    isSubmitted : isDraft ? 0 : 1
                };

                for (let i = 0; i < days.length; i++) {
                    const day = days[i];
                    const productionDate = currentWeekDates[day];
                    // Mon-Wed are "past" days (indices 0,1,2), Thu-Sun are "future" days (indices 3,4,5,6)
                    const isPastDay = i <= 2; // Mon=0, Tue=1, Wed=2

                    let oldEntry = {
                        ...oldCascadeObj,
                        productionDate,
                        Flag: 'M2',
                        Plan: isPastDay ? Number(obj[day]) : 0,
                        Mon: (day === 'Mon') ? Number(obj["Mon"]) : 0,
                        Tue: (day === 'Tue') ? Number(obj["Tue"]) : 0,
                        Wed: (day === 'Wed') ? Number(obj["Wed"]) : 0,
                        Thu: 0,
                        Fri: 0,
                        Sat: 0,
                        Sun: 0,
                        entry:'old'
                    };

                    let newEntry = {
                        ...newCascadeObj,
                        productionDate,
                        Flag: 'M2',
                        Plan: isPastDay ? 0 : Number(obj[day]),
                        Mon: 0,
                        Tue: 0,
                        Wed: 0,
                        Thu: (day === 'Thu') ? Number(obj["Thu"]) : 0,
                        Fri: (day === 'Fri') ? Number(obj["Fri"]) : 0,
                        Sat: (day === 'Sat') ? Number(obj["Sat"]) : 0,
                        Sun: (day === 'Sun') ? Number(obj["Sun"]) : 0,
                        entry:'new'
                    };

                    arr.push(oldEntry);
                    arr.push(newEntry);
                }
            } else {
                // No Cascade/Line change, create 7 entries (one per day)
                for (let i = 0; i < days.length; i++) {
                    let tem_obj = {
                        ...obj,
                        productionDate: currentWeekDates[days[i]],
                        Cascade: obj.Cascade,
                        Line: obj.Line,
                        PreCascade: obj.Cascade === constValues.Cascade ? obj.PreCascade : constValues.Cascade,
                        PreLine: obj.Line === constValues.Line ? obj.PreLine : constValues.Line,
                        Flag: 'M2',
                        Plan: Number(obj[days[i]]),
                        Mon: "Mon" === days[i] ? Number(obj["Mon"]) : 0,
                        Tue: "Tue" === days[i] ? Number(obj["Tue"]) : 0,
                        Wed: "Wed" === days[i] ? Number(obj["Wed"]) : 0,
                        Thu: "Thu" === days[i] ? Number(obj["Thu"]) : 0,
                        Fri: "Fri" === days[i] ? Number(obj["Fri"]) : 0,
                        Sat: "Sat" === days[i] ? Number(obj["Sat"]) : 0,
                        Sun: "Sun" === days[i] ? Number(obj["Sun"]) : 0,
                        "Reason for change": obj["Reason for change"],
                        requirement: obj["SAP weekly plan"],
                        IsDraft: isDraft ? 1 : 0,
                        IsIgnore: 1,
                        IsAddNewCBU: 0,
                        isSubmitted: isDraft ? 0 : 1
                    };
                    arr.push(tem_obj);
                }
            }
            return arr;
        }
        
        for (let i = 0; i < days.length; i++) {
            if (obj.IsAddNewCBU) {
                let tem_obj = {
                    ...obj,
                    productionDate: currentWeekDates[days[i]],
                    Cascade: obj.Cascade,
                    Line: obj.Line,
                    PreCascade: obj.Cascade,
                    PreLine: obj.Line,
                    Plan: Number(obj[days[i]]),
                    Mon: "Mon" === days[i] ? Number(obj["Mon"]) : 0,
                    Tue: "Tue" === days[i] ? Number(obj["Tue"]) : 0,
                    Wed: "Wed" === days[i] ? Number(obj["Wed"]) : 0,
                    Thu: "Thu" === days[i] ? Number(obj["Thu"]) : 0,
                    Fri: "Fri" === days[i] ? Number(obj["Fri"]) : 0,
                    Sat: "Sat" === days[i] ? Number(obj["Sat"]) : 0,
                    Sun: "Sun" === days[i] ? Number(obj["Sun"]) : 0,
                    "Reason for change": obj["Reason for change"],
                    requirement: obj["SAP weekly plan"],
                    IsDraft: isDraft ? 1 : 0,
                    IsIgnore: 1,
                    IsAddNewCBU: 1,
                    isSubmitted : isDraft ? 0 : 1
                }
                arr.push(tem_obj);
            } else if(obj.IsDuplicateRow){
                let tem_obj = {
                    ...obj,
                    productionDate: currentWeekDates[days[i]],
                    Cascade: obj.Cascade,
                    Line: obj.Line,
                    PreCascade: obj.Flag === 'M1' ? obj.Cascade : obj.PreCascade,
                    PreLine: obj.Flag === 'M1' ? obj.Line : obj.PreLine,
                    Plan: Number(obj[days[i]]),
                    Mon: "Mon" === days[i] ? Number(obj["Mon"]) : 0,
                    Tue: "Tue" === days[i] ? Number(obj["Tue"]) : 0,
                    Wed: "Wed" === days[i] ? Number(obj["Wed"]) : 0,
                    Thu: "Thu" === days[i] ? Number(obj["Thu"]) : 0,
                    Fri: "Fri" === days[i] ? Number(obj["Fri"]) : 0,
                    Sat: "Sat" === days[i] ? Number(obj["Sat"]) : 0,
                    Sun: "Sun" === days[i] ? Number(obj["Sun"]) : 0,
                    "Reason for change": obj["Reason for change"],
                    requirement: obj["SAP weekly plan"],
                    IsDraft: isDraft ? 1 : 0,
                    IsIgnore: 1,
                    IsAddNewCBU: 1,
                    isSubmitted : isDraft ? 0 : 1
                }
                arr.push(tem_obj);
            }
             else {
                // for M1 flag
                if (obj.Flag === 'M1') {
                    let tem_obj = {
                        ...obj,
                        productionDate: currentWeekDates[days[i]],
                        Cascade: obj.Cascade,
                        Line: obj.Line,
                        PreCascade: obj.Cascade === constValues.Cascade ? obj.PreCascade : constValues.Cascade,
                        PreLine: obj.Line === constValues.Line ? obj.PreLine : constValues.Line,
                        // Flag: getCurrentManualFlag(),
                        Plan: Number(obj[days[i]]),
                        Mon: "Mon" === days[i] ? Number(obj["Mon"]) : 0,
                        Tue: "Tue" === days[i] ? Number(obj["Tue"]) : 0,
                        Wed: "Wed" === days[i] ? Number(obj["Wed"]) : 0,
                        Thu: "Thu" === days[i] ? Number(obj["Thu"]) : 0,
                        Fri: "Fri" === days[i] ? Number(obj["Fri"]) : 0,
                        Sat: "Sat" === days[i] ? Number(obj["Sat"]) : 0,
                        Sun: "Sun" === days[i] ? Number(obj["Sun"]) : 0,
                        "Reason for change": obj["Reason for change"],
                        requirement: obj["SAP weekly plan"],
                        IsDraft: isDraft ? 1 : 0,
                        IsIgnore: 1,
                        IsAddNewCBU: 0,
                        isSubmitted : isDraft ? 0 : 1
                    }
                    arr.push(tem_obj);
                    // need to check if the cascade and line are different from old values.
                    if (obj.Cascade !== constValues.Cascade || obj.Line !== constValues.Line) {
                        let tem_obj_old;
                        tem_obj_old = {
                            ...obj,
                            productionDate: currentWeekDates[days[i]],
                            Cascade: constValues.Cascade,
                            Line: constValues.Line,
                            PreCascade: constValues?.preCascade ? constValues?.preCascade : constValues.Cascade, // need to delete this entry in BE so passing old value
                            PreLine: constValues?.preLine ? constValues?.preLine : constValues.Line, // need to delete this entry in BE so passing old value
                            requirement: obj["SAP weekly plan"],
                            "Reason for change": constValues["Reason for change"],
                            Plan: i < dayIndex ? Number(obj[days[i]]) : 0,
                            Mon: ("Mon" === days[i] && i < dayIndex) ? Number(obj["Mon"]) : 0,
                            Tue: ("Tue" === days[i] && i < dayIndex) ? Number(obj["Tue"]) : 0,
                            Wed: ("Wed" === days[i] && i < dayIndex) ? Number(obj["Wed"]) : 0,
                            Thu: ("Thu" === days[i] && i < dayIndex) ? Number(obj["Thu"]) : 0,
                            Fri: ("Fri" === days[i] && i < dayIndex) ? Number(obj["Fri"]) : 0,
                            Sat: ("Sat" === days[i] && i < dayIndex) ? Number(obj["Sat"]) : 0,
                            Sun: ("Sun" === days[i] && i < dayIndex) ? Number(obj["Sun"]) : 0,
                            IsDraft: isDraft ? 1 : 0,
                            IsIgnore: obj.Flag === 'M1' ? 0 : 1,
                            IsAddNewCBU: 0,
                            isSubmitted : isDraft ? 0 : 1
                        }
                        arr.push(tem_obj_old);
                    }
                }
            }
        }
        console.log("differentiated arr:", arr);
        return arr;
    } catch (err) {

    }
}

// for smart prod schedular
export const timeBasedFlag = () => {
    const now = new Date();
    const day = now.getDay();
    const hours = now.getHours();
    const minutes = now.getMinutes();

    const totalMinutes = hours * 60 + minutes;
    const threshold = 13 * 60 + 10;

    if (day === 4) {
        // Thursday special case
        // return totalMinutes < threshold ? "M1" : "M2"; commented coz business asked to remove M2
        return totalMinutes < threshold ? "M1" : "M1";
    }

    if (day === 5) {
        // Friday → always M2
        // return "M2"; commented coz business asked to remove M2
        return "M1";
    }

    if (day === 6) {
        // Saturday special case
        // return totalMinutes < threshold ? "M2" : "M1"; commented coz business asked to remove M2
        return totalMinutes < threshold ? "M1" : "M1";
    }

    // Sunday(0) → Wednesday(3) → always M1
    return "M1";
}

// for DPR
export const timeBasedFlagDPR = () => {
    const now = new Date();
    const day = now.getDay();
    const hours = now.getHours();
    const minutes = now.getMinutes();

    const totalMinutes = hours * 60 + minutes;
    const threshold = 13 * 60 + 10;

    if (day === 4) {
        // Thursday special case
        // return totalMinutes < threshold ? "M1" : "M2"; commented coz business asked to remove M2
        return totalMinutes < threshold ? "M1" : "M1";
    }

    if (day === 5 || day === 6 || day === 0) {
        // Friday → always M2
        // return "M2"; commented coz business asked to remove M2
        return "M1";
    }

    // monday(1) to Wednesday(3) → always M1
    return "M1";
}

// Check if a day field should be disabled based on current day
export const isPastDay = (fieldLabel) => {
    const { day } = getCurrentISODayTime();
    
    const dayIndices = {
        Mon: 0, 
        Tue: 1, 
        Wed: 2,
        Thu: 3, 
        Fri: 4, 
        Sat: 5,
        Sun: 6
    };
    
    // Fields that are not day fields (always enabled)
    const alwaysEnabledFields = [
        'Cascade', 
        'Line', 
        'Reason for change', 
        'Priority', 
        'Site code', 
        'Format',
        'CBU code',
        'Site cluster',
        'Basepack',
        'Basepack description',
        'CBU description'
    ];
    
    // If field is not a day field, it should not be disabled
    if (alwaysEnabledFields.includes(fieldLabel)) {
        return false;
    }
    
    // Get current day index
    const currentDayIndex = dayIndices[day];
    
    // Get field day index
    const fieldDayIndex = dayIndices[fieldLabel];
    
    // If field is not a recognized day, don't disable
    if (fieldDayIndex === undefined) {
        return false;
    }
    
    // Disable if field day is before current day
    return fieldDayIndex < currentDayIndex;
};

// Get week filter options based on current day and SQL refresh cycle
// SQL refreshes: Thursday 1:15 PM and Saturday 1:15 PM
// Always shows 2 weeks of data:
// Thursday 1:15 PM to Saturday 1:15 PM: Current week & Current week + 1
// Saturday 1:15 PM onwards: Current week & Current week + 1
// Monday onwards: Current week + 1 & Current week + 2
export const getWeekFilterOptions = () => {
    const now = new Date();
    const currentDay = now.getDay(); // 0 = Sunday, 6 = Saturday
    const currentHours = now.getHours();
    const currentMinutes = now.getMinutes();
    const totalMinutes = currentHours * 60 + currentMinutes;
    const threshold = 13 * 60 + 15; // 1:15 PM (13:15)
    
    // Get ISO week number
    const getISOWeekNumber = (date) => {
        const tmpDate = new Date(date.getTime());
        tmpDate.setHours(0, 0, 0, 0);
        tmpDate.setDate(tmpDate.getDate() + 3 - ((tmpDate.getDay() + 6) % 7));
        const week1 = new Date(tmpDate.getFullYear(), 0, 4);
        return 1 + Math.round(
            ((tmpDate.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7
        );
    };
    
    const currentWeek = getISOWeekNumber(now);
    
    // Thursday (4) after 1:15 PM to Saturday (6) before 1:15 PM: Current week & Current week + 1
    if ((currentDay === 4 && totalMinutes >= threshold) || // Thursday after 1:15 PM
        currentDay === 5 || // Friday
        (currentDay === 6 && totalMinutes < threshold)) { // Saturday before 1:15 PM
        return [
            `Week ${currentWeek}`,
            `Week ${currentWeek + 1}`
        ];
    }
    // Saturday (6) after 1:15 PM to Sunday (0): Current week & Current week + 1
    else if ((currentDay === 6 && totalMinutes >= threshold) || // Saturday after 1:15 PM
             currentDay === 0) { // Sunday
        return [
            `Week ${currentWeek}`,
            `Week ${currentWeek + 1}`
        ];
    }
    // Monday (1) to Thursday (4) before 1:15 PM: Current week + 1 & Current week + 2
    else {
        return [
            `Week ${currentWeek}`,
            `Week ${currentWeek + 1}`
        ];
    }
};

// Get flag value based on selected week and SQL refresh cycle
// SQL refreshes: Thursday 1:15 PM and Saturday 1:15 PM
// Always 2 weeks visible:
// Thursday 1:15 PM to Saturday 1:15 PM: Current week (M2) & Current week + 1 (S1)
// Saturday 1:15 PM to Sunday: Current week (M2) & Current week + 1 (M1)
// Monday to Thursday 1:15 PM: Current week + 1 (M1) & Current week + 2 (S1)
export const getWeekBasedFlag = (selectedWeek) => {
    if (!selectedWeek) return "M1"; // Default flag
    
    const now = new Date();
    const currentDay = now.getDay(); // 0 = Sunday, 6 = Saturday
    const currentHours = now.getHours();
    const currentMinutes = now.getMinutes();
    const totalMinutes = currentHours * 60 + currentMinutes;
    const threshold = 13 * 60 + 15; // 1:15 PM (13:15)
    
    // Get ISO week number
    const getISOWeekNumber = (date) => {
        const tmpDate = new Date(date.getTime());
        tmpDate.setHours(0, 0, 0, 0);
        tmpDate.setDate(tmpDate.getDate() + 3 - ((tmpDate.getDay() + 6) % 7));
        const week1 = new Date(tmpDate.getFullYear(), 0, 4);
        return 1 + Math.round(
            ((tmpDate.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7
        );
    };
    
    const currentWeek = getISOWeekNumber(now);
    
    // Extract week number from selectedWeek string (e.g., "Week 45" -> 45)
    const selectedWeekNumber = parseInt(selectedWeek.replace('Week ', ''));
    
    // Thursday (4) after 1:15 PM to Saturday (6) before 1:15 PM: Current week (M2) & Current week + 1 (S1)
    if ((currentDay === 4 && totalMinutes >= threshold) || // Thursday after 1:15 PM
        currentDay === 5 || // Friday
        (currentDay === 6 && totalMinutes < threshold)) { // Saturday before 1:15 PM
        
        if (selectedWeekNumber === currentWeek) {
            // return "M2"; commented coz business asked to remove M2
            return "M1"; // Current week
        } else if (selectedWeekNumber === currentWeek + 1) {
            return "S1"; // Current week + 1
        }
    }
    // Saturday (6) after 1:15 PM to Sunday (0): Current week (M2) & Current week + 1 (M1)
    else if ((currentDay === 6 && totalMinutes >= threshold) || // Saturday after 1:15 PM
             currentDay === 0) { // Sunday
        
        if (selectedWeekNumber === currentWeek) {
            // return "M2"; commented coz business asked to remove M2
            return "M1";
        } else if (selectedWeekNumber === currentWeek + 1) {
            return "M1"; // Current week + 1
        }
    }
    // Monday (1) to Thursday (4) before 1:15 PM: Current week + 1 (M1) & Current week + 2 (S1)
    else {
        if (selectedWeekNumber === currentWeek + 1) {
            return "M1"; // Current week + 1
        } else if (selectedWeekNumber === currentWeek + 2) {
            return "S1"; // Current week + 2
        }
    }
    
    // Default fallback
    return "M1";
};

    // Check if any row has Flag 'S1'
export const hasS1Flag = (data) => {
    return data.some(item => item.Flag === 'S1');
};

export { getCurrentManualFlag };